import { create } from 'zustand';

export type DragPhase = 'none' | 'dragging' | 'hovering' | 'holding' | 'opening';

export interface DragToBoardState {
  // Drag state
  isDragging: boolean;
  draggedItemIds: string[];
  
  // Hover over board state
  hoverBoardId: string | null;
  hoverStartTime: number | null;
  hoverPhase: DragPhase;
  hoverProgress: number;
  
  // Phase timings (ms)
  PHASE_TIMINGS: {
    HOVER_TO_HOLD: number;
    HOLD_TO_OPEN: number;
  };
  
  // Actions
  startDrag: (itemIds: string[]) => void;
  endDrag: () => void;
  enterBoard: (linkedBoardId: string) => void;
  leaveBoard: () => void;
  setProgress: (progress: number, phase: DragPhase) => void;
  setOpening: () => void;
  reset: () => void;
}

export const useDragToBoardStore = create<DragToBoardState>((set) => ({
  isDragging: false,
  draggedItemIds: [],
  hoverBoardId: null,
  hoverStartTime: null,
  hoverPhase: 'none',
  hoverProgress: 0,
  
  PHASE_TIMINGS: {
    HOVER_TO_HOLD: 500,    // ms before progress starts
    HOLD_TO_OPEN: 1500,    // ms of holding before board opens
  },
  
  startDrag: (itemIds) => set({
    isDragging: true,
    draggedItemIds: itemIds,
    hoverPhase: 'dragging',
  }),
  
  endDrag: () => set({
    isDragging: false,
    draggedItemIds: [],
    hoverBoardId: null,
    hoverStartTime: null,
    hoverPhase: 'none',
    hoverProgress: 0,
  }),
  
  enterBoard: (linkedBoardId) => set({
    hoverBoardId: linkedBoardId,
    hoverStartTime: Date.now(),
    hoverPhase: 'hovering',
    hoverProgress: 0,
  }),
  
  leaveBoard: () => set({
    hoverBoardId: null,
    hoverStartTime: null,
    hoverPhase: 'dragging',
    hoverProgress: 0,
  }),
  
  setProgress: (progress, phase) => set({
    hoverProgress: progress,
    hoverPhase: phase,
  }),
  
  setOpening: () => set({
    hoverPhase: 'opening',
    hoverProgress: 100,
  }),
  
  reset: () => set({
    isDragging: false,
    draggedItemIds: [],
    hoverBoardId: null,
    hoverStartTime: null,
    hoverPhase: 'none',
    hoverProgress: 0,
  }),
}));
